/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import Supplier from './Supplier';
import Goods from './Goods';
import GoodsCat from './GoodsCat';
import Prop from './Prop';
import Value from './Value';
import GoodsTypeSet from './GoodsTypeSet';

export default {
    Supplier,
    Goods,
    GoodsCat,
    Prop,
    Value,
    GoodsTypeSet,
};
